<template>
  <div class="hello">
        <transition name="fade">
            <div v-if="gettingOrder" class="loading">
                <p>Getting Order Details...</p>
            </div>
        </transition>

        <transition name="fade">
            <div v-if="showSuccess" class="loading">
                <p>Order Change Updated</p>
            </div>
        </transition>

    <b-container>
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Change Order Request from {{order.brewer}}</h4>
            </b-col>
        </b-row>
        <hr>
        <!-- Error message -->
        <div style="color:red" v-if="errMsg">{{errMsg}}</div>

        <!-- If not logged in, show login modal and button -->
        <div v-if="!isTheUserLoggedIn">
            <h6>You just be logged in to acept or reject this change</h6>
            <b-button variant='info' @click="showLoginModal=true">Login</b-button>
            <!-- Login modal -->
            
            <b-modal title="Must be logged in" v-model="showLoginModal" id="theloginmodal" :hide-footer="true">
                <loginmodal @closeLoginModal="closeLoginModal" id='loginmodal' />
            </b-modal>
        </div>

        <!-- Order. Show only if logged in -->
        <div v-if="isTheUserLoggedIn">
            <b-row style="margin-top:20px">
                <b-col>
                    <h5><span style="color:#2e5189">Original Order: </span> {{order.beerName}}</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189">Suggested Change To:</span> {{order.suggestedbeername}}</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189">New Package: </span> {{order.suggestedsize}}</h5>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189">New Cost:</span> ${{order.suggestedcost}}</h5>
                </b-col>
            </b-row>

            <b-row  style="margin-top:20px" v-if="order.sellernote">
                <b-col>
                    <h6>{{order.sellernote}}</h6>
                </b-col>
            </b-row>
            
            <hr>
            <!-- Show change buttons only if change not accepted yet, and correct user logged in -->
            <div v-if="order.suggestedstatus==1&&isCorrectUser">
                <!-- Accept change -->
                <b-row style="margin-top:20px">
                    <b-col>
                        <b-button size="lg" variant="success" @click="acceptChange">Accept Change</b-button>
                    </b-col>
                </b-row>

                <!-- Reject change -->
                <b-row>
                    <b-col>
                        <b-button  size="lg" style="margin-top:20px" variant="outline-danger" @click="rejectChange">Reject Change</b-button>
                    </b-col>
                </b-row>
            </div>
            <!-- Else show already updated -->
            <div v-if="order.suggestedstatus==2||order.suggestedstatus==3&&isCorrectUser">
                <h4>This order has already been updated</h4>
            </div>

        </div>
        
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import Loginmodal from '../Loginmodal'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Loginmodal
    },

    data() {
        return {
            errMsg:"",
            gettingOrder:false,
            suborderid:'',
            acceptStatus:'',
            order:{},
            cancelMessage:'',
            isTheUserLoggedIn:false,
            performingRequest:false,
            showLoginModal:false,
            isCorrectUser:false,
            showSuccess:false,
        }
    },

    methods:{
        //Get the order
        getOrder(){
            this.gettingOrder=true
            var fbref = fb.ordersCollection
            console.log("Getting order")
            fbref.where('suborderid', '==', this.suborderid).get().then(docs => {
                this.gettingOrder=false
                docs.forEach(doc => {
                    let theOrderData = doc.data()
                    theOrderData.docId=doc.id
                    this.order = theOrderData
                    this.isTheUserLoggedIn=true
                    this.performingRequest = false
                    //Check if correct user logged in
                    if(this.currentUser.uid!=theOrderData.pubid){
                        this.errMsg="The order does not belong to the current user"
                        this.isCorrectUser=false
                    }
                    else this.isCorrectUser=true

                })
            }).then(res => {
                this.gettingOrder=false
            })
            .catch(err => {
                this.gettingOrder=false
                console.log(err)
            })
        },

        //Accept change
        acceptChange(){
            console.log("Accepting change")
            var localOrder = this.order
            localOrder.suggestedstatus=2
            localOrder.status=1
            //Save original order
            localOrder.origbeername=localOrder.beerName
            localOrder.origbeerid=localOrder.beerId
            localOrder.origsize=localOrder.size
            localOrder.origcost=localOrder.cost

            //Modify to new order
            localOrder.beerName=localOrder.suggestedbeername
            localOrder.beerId=localOrder.suggestedbeerid
            localOrder.cost=localOrder.suggestedcost
            localOrder.size=localOrder.suggestedsize
            fb.ordersCollection.doc(localOrder.docId).update(localOrder)
            this.$bvToast.toast('This order change has been Accepted', {
                title: 'Change Accepted',
                solid:true,
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: false
            })

            this.showSuccess=true
            setTimeout(() => { 
                this.showSuccess = false 
                this.$router.push({path:'/login'})
            }, 1500)
        },

        //Accept change
        rejectChange(){
            console.log("Rejecting Change")
            console.log("Rejecting change")
            this.cancelMessage=this.userProfile.company + ' rejected change to ' + this.order.suggestedbeername
            console.log("message: " + this.cancelMessage)
            //Update status and cancel order
            var cancelData = {
                cancelledBy:this.order.brewer,
                cancelMessage:this.cancelMessage,
                suggestedstatus:3,
                status:-1,
                cancelledOn: new Date(),
            }
            fb.ordersCollection.doc(this.order.docId).update(cancelData)
            this.$bvToast.toast('This order change has been Rejected', {
                title: 'Change Rejected!',
                solid:true,
                variant: 'danger',
                autoHideDelay: 5000,
                appendToast: false
            })
            this.showSuccess=true
            setTimeout(() => { 
                this.showSuccess = false 
                this.$router.push({path:'/login'})
            }, 1500)
            
        },

        //Close login modal
        closeLoginModal(modalid, success){
            console.log("Received login modalid=" + modalid)
            console.log("Received login success=" + success)
            if(success){
                this.isTheUserLoggedIn=true
                this.getOrder()
            } 
            else this.isTheUserLoggedIn=false
            this.showLoginModal=false
        },
    },

    mounted(){
        this.errMsg=""
        this.isTheUserLoggedIn=false
        if(this.$route.params.suborderid ){
            this.suborderid = this.$route.params.suborderid
        }
        if(this.$route.params.acceptstatus ){
            this.acceptStatus = this.$route.params.acceptstatus
        }
        //Check valid suborderid and status
        if(!this.$route.params.suborderid) this.errMsg="Invalid Order"

        //Check logged in
        if(this.currentUser){
            console.log("User exists")
            this.isTheUserLoggedIn=true
            this.getOrder()
        } 
        else{
            console.log("No user")
            this.isTheUserLoggedIn=false
            this.showLoginModal=true
        }
    },
}
</script>

